(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-countdown-timer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeTimer = (timer) => {
      if (timer.dataset.timerInitialized === 'true') return;
      const endTime = new Date(timer.dataset.endDate).getTime();
      if (Number.isNaN(endTime)) return;
      timer.dataset.timerInitialized = 'true';
      const units = timer.querySelector('[data-timer-units]');
      const expired = timer.querySelector('[data-timer-expired]');
      const values = {
        days: timer.querySelector('[data-timer-days]'),
        hours: timer.querySelector('[data-timer-hours]'),
        minutes: timer.querySelector('[data-timer-minutes]'),
        seconds: timer.querySelector('[data-timer-seconds]')
      };
      const update = () => {
        const remaining = endTime - Date.now();
        if (remaining <= 0) {
          window.clearInterval(timer.collectionTimerInterval);
          if (timer.dataset.hideExpired === 'true') {
            timer.hidden = true;
          } else {
            units.hidden = true;
            expired.textContent = timer.dataset.expiredMessage;
            expired.hidden = false;
          }
          return;
        }
        const totalSeconds = Math.floor(remaining / 1000);
        values.days.textContent = String(Math.floor(totalSeconds / 86400)).padStart(2, '0');
        values.hours.textContent = String(Math.floor(totalSeconds / 3600) % 24).padStart(2, '0');
        values.minutes.textContent = String(Math.floor(totalSeconds / 60) % 60).padStart(2, '0');
        values.seconds.textContent = String(totalSeconds % 60).padStart(2, '0');
      };
      update();
      timer.collectionTimerInterval = window.setInterval(update, 1000);
    };
    const initializeAll = (root = document) => root.querySelectorAll('[data-collection-timer]').forEach(initializeTimer);
    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('[data-collection-timer]').forEach((timer) => window.clearInterval(timer.collectionTimerInterval));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const choices = new Map();
    const storageKey = 'collection-mobile-grid-columns';

    const setView = (controls, columns) => {
      const scope = controls.closest('[data-mobile-grid-scope]');
      const grid = scope?.querySelector('[data-mobile-product-grid]');
      if (!grid) return;

      grid.dataset.mobileColumns = columns;
      controls.querySelectorAll('[data-mobile-grid-button]').forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.mobileGridButton === columns));
      });
    };

    const getSavedView = (controls) => {
      if (choices.has(storageKey)) return choices.get(storageKey);
      if (controls.dataset.rememberChoice === 'true') {
        try {
          const saved = window.localStorage.getItem(storageKey);
          if (saved === '1' || saved === '2') return saved;
        } catch (error) {
          return controls.dataset.defaultColumns;
        }
      }
      return controls.dataset.defaultColumns;
    };

    const initialize = (root = document) => {
      root.querySelectorAll('[data-mobile-grid-controls]').forEach((controls) => {
        if (controls.dataset.mobileGridInitialized === 'true') return;
        controls.dataset.mobileGridInitialized = 'true';
        setView(controls, getSavedView(controls));
      });
    };

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-mobile-grid-button]');
      if (!button) return;

      const controls = button.closest('[data-mobile-grid-controls]');
      const columns = button.dataset.mobileGridButton;
      const update = () => setView(controls, columns);

      choices.set(storageKey, columns);
      if (controls.dataset.rememberChoice === 'true') {
        try {
          window.localStorage.setItem(storageKey, columns);
        } catch (error) {
          choices.set(storageKey, columns);
        }
      }

      if (document.startViewTransition) {
        document.startViewTransition(update);
      } else {
        update();
      }
    });

    initialize();
    document.addEventListener('collection:reloaded', () => initialize());
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rqs-main-collection-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const instances =
      window.rqsLatestCollectionGridInstances || new Map();

    window.rqsLatestCollectionGridInstances = instances;

    class RqsLatestCollectionGrid {
      constructor(root) {
        this.root = root;
        this.track = root.querySelector('[data-rqs-colgrid-track]');
        this.previous = root.querySelector('[data-rqs-colgrid-prev]');
        this.next = root.querySelector('[data-rqs-colgrid-next]');
        this.dots = root.querySelector('[data-rqs-colgrid-dots]');
        this.controls = root.querySelector('.rqs-colgrid-mobilecontrols');

        this.slides = this.track
          ? Array.from(
              this.track.querySelectorAll('[data-rqs-colgrid-slide]')
            )
          : [];

        this.breakpoint =
          Number(root.dataset.rqsBreakpoint) || 750;

        this.autoplayEnabled =
          root.dataset.rqsAutoplay === 'true';

        this.autoplaySpeed =
          Number(root.dataset.rqsAutoplaySpeed) || 5000;

        this.mobileQuery = window.matchMedia(
          `(max-width: ${this.breakpoint}px)`
        );

        this.pageOffsets = [0];
        this.pageCount = 1;
        this.currentPage = 0;

        this.autoplayTimer = null;
        this.scrollTimer = null;
        this.resizeTimer = null;
        this.scrollRaf = null;
        this.resizeObserver = null;

        this.handleScroll = this.handleScroll.bind(this);
        this.handleScrollEnd = this.handleScrollEnd.bind(this);
        this.handleBreakpoint = this.handleBreakpoint.bind(this);
        this.handleVisibility = this.handleVisibility.bind(this);
        this.handleResize = this.handleResize.bind(this);

        if (!this.track || !this.slides.length) {
          return;
        }

        this.previous?.addEventListener('click', () => {
          this.goToPage(this.currentPage - 1);
          this.restartAutoplay();
        });

        this.next?.addEventListener('click', () => {
          this.goToPage(this.currentPage + 1);
          this.restartAutoplay();
        });

        this.track.addEventListener(
          'scroll',
          this.handleScroll,
          {
            passive: true
          }
        );

        if ('onscrollend' in window) {
          this.track.addEventListener(
            'scrollend',
            this.handleScrollEnd,
            {
              passive: true
            }
          );
        }

        this.track.addEventListener(
          'pointerdown',
          () => this.stopAutoplay(),
          {
            passive: true
          }
        );

        this.track.addEventListener(
          'touchstart',
          () => this.stopAutoplay(),
          {
            passive: true
          }
        );

        this.track.addEventListener(
          'pointerup',
          () => this.startAutoplay(),
          {
            passive: true
          }
        );

        this.track.addEventListener(
          'touchend',
          () => this.startAutoplay(),
          {
            passive: true
          }
        );

        this.root.addEventListener(
          'focusin',
          () => this.stopAutoplay()
        );

        this.root.addEventListener(
          'focusout',
          event => {
            if (!this.root.contains(event.relatedTarget)) {
              this.startAutoplay();
            }
          }
        );

        if (this.mobileQuery.addEventListener) {
          this.mobileQuery.addEventListener(
            'change',
            this.handleBreakpoint
          );
        } else {
          this.mobileQuery.addListener(
            this.handleBreakpoint
          );
        }

        document.addEventListener(
          'visibilitychange',
          this.handleVisibility
        );

        window.addEventListener(
          'resize',
          this.handleResize,
          {
            passive: true
          }
        );

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => {
            window.clearTimeout(this.resizeTimer);

            this.resizeTimer = window.setTimeout(() => {
              this.refresh(true);
            }, 80);
          });

          this.resizeObserver.observe(this.track);
        }

        this.refresh(true);
      }

      isMobile() {
        return this.mobileQuery.matches;
      }

      getGap() {
        const styles =
          window.getComputedStyle(this.track);

        const gap =
          parseFloat(
            styles.columnGap ||
            styles.gap ||
            '0'
          );

        return Number.isFinite(gap)
          ? gap
          : 0;
      }

      getSlideWidth() {
        return (
          this.slides[0]
            ?.getBoundingClientRect()
            .width || 0
        );
      }

      getVisibleCount() {
        const slideWidth =
          this.getSlideWidth();

        const gap =
          this.getGap();

        if (!slideWidth) {
          return 1;
        }

        return Math.max(
          1,
          Math.min(
            this.slides.length,
            Math.round(
              (this.track.clientWidth + gap) /
              (slideWidth + gap)
            )
          )
        );
      }

      getMaxScroll() {
        return Math.max(
          0,
          this.track.scrollWidth -
          this.track.clientWidth
        );
      }

      getScrollLeft() {
        return Math.max(
          0,
          Math.min(
            this.getMaxScroll(),
            this.track.scrollLeft
          )
        );
      }

      buildPageOffsets() {
        const visibleCount =
          this.getVisibleCount();

        const maxScroll =
          this.getMaxScroll();

        const offsets = [];

        for (
          let index = 0;
          index < this.slides.length;
          index += visibleCount
        ) {
          const slide =
            this.slides[index];

          if (!slide) {
            continue;
          }

          const offset =
            Math.max(
              0,
              Math.min(
                maxScroll,
                slide.offsetLeft
              )
            );

          if (
            !offsets.length ||
            Math.abs(
              offset -
              offsets[offsets.length - 1]
            ) > 1
          ) {
            offsets.push(offset);
          }
        }

        if (!offsets.length) {
          offsets.push(0);
        }

        if (
          maxScroll > 1 &&
          Math.abs(
            offsets[offsets.length - 1] -
            maxScroll
          ) > 1
        ) {
          offsets.push(maxScroll);
        }

        this.pageOffsets = offsets;
        this.pageCount = offsets.length;
      }

      getCurrentPage() {
        const position =
          this.getScrollLeft();

        let closestIndex = 0;
        let closestDistance = Infinity;

        this.pageOffsets.forEach(
          (offset, index) => {
            const distance =
              Math.abs(
                position - offset
              );

            if (
              distance <
              closestDistance
            ) {
              closestDistance =
                distance;

              closestIndex =
                index;
            }
          }
        );

        return closestIndex;
      }

      buildDots() {
        if (!this.dots) {
          return;
        }

        this.dots.innerHTML = '';

        if (
          !this.isMobile() ||
          this.pageCount <= 1
        ) {
          this.dots.hidden = true;
          return;
        }

        this.dots.hidden = false;

        for (
          let index = 0;
          index < this.pageCount;
          index += 1
        ) {
          const dot =
            document.createElement(
              'button'
            );

          dot.type = 'button';

          dot.className =
            'rqs-colgrid-dot';

          dot.setAttribute(
            'aria-label',
            `Go to collection slide ${index + 1}`
          );

          dot.addEventListener(
            'click',
            () => {
              this.goToPage(index);
              this.restartAutoplay();
            }
          );

          this.dots.appendChild(dot);
        }
      }

      updateControls(forcePage = null) {
        if (!this.isMobile()) {
          return;
        }

        this.currentPage =
          Number.isInteger(forcePage)
            ? Math.max(
                0,
                Math.min(
                  this.pageCount - 1,
                  forcePage
                )
              )
            : this.getCurrentPage();

        if (this.previous) {
          this.previous.disabled =
            this.currentPage <= 0;

          this.previous.setAttribute(
            'aria-disabled',
            String(
              this.previous.disabled
            )
          );
        }

        if (this.next) {
          this.next.disabled =
            this.currentPage >=
            this.pageCount - 1;

          this.next.setAttribute(
            'aria-disabled',
            String(
              this.next.disabled
            )
          );
        }

        if (this.controls) {
          this.controls.hidden =
            this.pageCount <= 1;
        }

        if (this.dots) {
          this.dots
            .querySelectorAll(
              '.rqs-colgrid-dot'
            )
            .forEach(
              (dot, index) => {
                const active =
                  index ===
                  this.currentPage;

                dot.classList.toggle(
                  'is-rqs-colgrid-active',
                  active
                );

                if (active) {
                  dot.setAttribute(
                    'aria-current',
                    'true'
                  );
                } else {
                  dot.removeAttribute(
                    'aria-current'
                  );
                }
              }
            );
        }
      }

      goToPage(index) {
        if (
          !this.isMobile() ||
          !this.pageOffsets.length
        ) {
          return;
        }

        const target =
          Math.max(
            0,
            Math.min(
              this.pageCount - 1,
              index
            )
          );

        const left =
          this.pageOffsets[target] ?? 0;

        const reducedMotion =
          window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;

        this.updateControls(target);

        this.track.scrollTo({
          left: left,
          behavior: reducedMotion
            ? 'auto'
            : 'smooth'
        });

        if (reducedMotion) {
          this.handleScrollEnd();
        }
      }

      handleScroll() {
        if (!this.isMobile()) {
          return;
        }

        if (this.scrollRaf) {
          cancelAnimationFrame(
            this.scrollRaf
          );
        }

        this.scrollRaf =
          requestAnimationFrame(() => {
            this.updateControls();

            this.scrollRaf = null;
          });

        if (
          !('onscrollend' in window)
        ) {
          window.clearTimeout(
            this.scrollTimer
          );

          this.scrollTimer =
            window.setTimeout(
              this.handleScrollEnd,
              90
            );
        }
      }

      handleScrollEnd() {
        if (!this.isMobile()) {
          return;
        }

        window.clearTimeout(
          this.scrollTimer
        );

        this.updateControls();
      }

      handleBreakpoint() {
        this.stopAutoplay();

        this.track.scrollLeft = 0;

        requestAnimationFrame(() => {
          this.refresh(true);
        });
      }

      handleResize() {
        window.clearTimeout(
          this.resizeTimer
        );

        this.resizeTimer =
          window.setTimeout(() => {
            this.refresh(true);
          }, 120);
      }

      handleVisibility() {
        if (document.hidden) {
          this.stopAutoplay();
        } else {
          this.startAutoplay();
        }
      }

      refresh(resetPosition = false) {
        this.slides =
          Array.from(
            this.track.querySelectorAll(
              '[data-rqs-colgrid-slide]'
            )
          );

        if (!this.isMobile()) {
          this.pageOffsets = [0];
          this.pageCount = 1;
          this.currentPage = 0;

          this.stopAutoplay();

          if (this.controls) {
            this.controls.hidden = false;
          }

          if (this.dots) {
            this.dots.innerHTML = '';
            this.dots.hidden = true;
          }

          if (this.previous) {
            this.previous.disabled = true;

            this.previous.setAttribute(
              'aria-disabled',
              'true'
            );
          }

          if (this.next) {
            this.next.disabled = true;

            this.next.setAttribute(
              'aria-disabled',
              'true'
            );
          }

          return;
        }

        if (resetPosition) {
          this.track.scrollLeft = 0;
        }

        requestAnimationFrame(() => {
          this.buildPageOffsets();

          this.currentPage =
            this.getCurrentPage();

          this.buildDots();

          this.updateControls();

          this.startAutoplay();
        });
      }

      startAutoplay() {
        if (
          !this.isMobile() ||
          !this.autoplayEnabled ||
          this.pageCount <= 1 ||
          document.hidden
        ) {
          return;
        }

        this.stopAutoplay();

        this.autoplayTimer =
          window.setInterval(() => {
            const target =
              this.currentPage >=
              this.pageCount - 1
                ? 0
                : this.currentPage + 1;

            this.goToPage(target);
          }, this.autoplaySpeed);
      }

      stopAutoplay() {
        if (!this.autoplayTimer) {
          return;
        }

        window.clearInterval(
          this.autoplayTimer
        );

        this.autoplayTimer = null;
      }

      restartAutoplay() {
        this.stopAutoplay();
        this.startAutoplay();
      }

      destroy() {
        this.stopAutoplay();

        window.clearTimeout(
          this.scrollTimer
        );

        window.clearTimeout(
          this.resizeTimer
        );

        if (this.scrollRaf) {
          cancelAnimationFrame(
            this.scrollRaf
          );
        }

        this.track
          ?.removeEventListener(
            'scroll',
            this.handleScroll
          );

        this.track
          ?.removeEventListener(
            'scrollend',
            this.handleScrollEnd
          );

        if (
          this.mobileQuery
            .removeEventListener
        ) {
          this.mobileQuery
            .removeEventListener(
              'change',
              this.handleBreakpoint
            );
        } else {
          this.mobileQuery
            .removeListener(
              this.handleBreakpoint
            );
        }

        document.removeEventListener(
          'visibilitychange',
          this.handleVisibility
        );

        window.removeEventListener(
          'resize',
          this.handleResize
        );

        this.resizeObserver
          ?.disconnect();
      }
    }

    const initialize = scope => {
      const roots =
        scope.matches?.(
          '[data-rqs-colgrid]'
        )
          ? [scope]
          : Array.from(
              scope.querySelectorAll?.(
                '[data-rqs-colgrid]'
              ) || []
            );

      roots.forEach(root => {
        const existing =
          instances.get(root.id);

        if (existing) {
          existing.destroy();

          instances.delete(
            root.id
          );
        }

        instances.set(
          root.id,
          new RqsLatestCollectionGrid(
            root
          )
        );
      });
    };

    initialize(document);

    document.addEventListener(
      'shopify:section:load',
      event => {
        initialize(
          event.target
        );
      }
    );

    document.addEventListener(
      'shopify:section:reorder',
      event => {
        initialize(
          event.target
        );
      }
    );

    document.addEventListener(
      'shopify:block:select',
      event => {
        const root =
          event.target.closest?.(
            '[data-rqs-colgrid]'
          );

        if (!root) {
          return;
        }

        const instance =
          instances.get(root.id);

        instance?.refresh(false);
      }
    );

    document.addEventListener(
      'shopify:section:unload',
      event => {
        const root =
          event.target.matches?.(
            '[data-rqs-colgrid]'
          )
            ? event.target
            : event.target.querySelector?.(
                '[data-rqs-colgrid]'
              );

        if (!root) {
          return;
        }

        const instance =
          instances.get(root.id);

        instance?.destroy();

        instances.delete(
          root.id
        );
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rqs-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const registry =
      window.rqsLuxLookSheetRegistry ||
      new Map();

    window.rqsLuxLookSheetRegistry = registry;

    class RqsLuxLookSheet {
      constructor(root) {
        this.root = root;

        this.hotspots = Array.from(
          root.querySelectorAll(
            '[data-rqs-luxlook-hotspot]'
          )
        );

        this.products = Array.from(
          root.querySelectorAll(
            '[data-rqs-luxlook-product]'
          )
        );

        this.productStage =
          root.querySelector(
            '[data-rqs-luxlook-product-stage]'
          );

        this.sheet =
          root.querySelector(
            '[data-rqs-luxlook-sheet]'
          );

        this.sheetPanel =
          root.querySelector(
            '[data-rqs-luxlook-sheet-panel]'
          );

        this.sheetBody =
          root.querySelector(
            '[data-rqs-luxlook-sheet-body]'
          );

        this.sheetTitle =
          root.querySelector(
            '[data-rqs-luxlook-sheet-title]'
          );

        this.closeButton =
          root.querySelector(
            '[data-rqs-luxlook-sheet-close]'
          );

        this.breakpoint =
          Number(
            root.dataset.rqsMobileBreakpoint
          ) || 750;

        this.mobileQuery =
          window.matchMedia(
            `(max-width: ${this.breakpoint}px)`
          );

        this.activeId =
          root.dataset.rqsInitialProduct || '';

        this.sheetProduct = null;

        this.handleBreakpoint =
          this.handleBreakpoint.bind(this);

        this.handleSheetClick =
          this.handleSheetClick.bind(this);

        this.handleSheetClose =
          this.handleSheetClose.bind(this);

        this.handleBlockSelect =
          this.handleBlockSelect.bind(this);

        if (
          !this.hotspots.length ||
          !this.products.length
        ) {
          return;
        }

        this.hotspots.forEach(hotspot => {
          hotspot.addEventListener(
            'click',
            () => {
              const id =
                hotspot.dataset
                  .rqsLuxlookHotspot;

              this.selectProduct(
                id,
                true
              );
            }
          );
        });

        this.closeButton?.addEventListener(
          'click',
          () => {
            this.closeSheet();
          }
        );

        this.sheet?.addEventListener(
          'click',
          this.handleSheetClick
        );

        this.sheet?.addEventListener(
          'close',
          this.handleSheetClose
        );

        this.mobileQuery.addEventListener(
          'change',
          this.handleBreakpoint
        );

        document.addEventListener(
          'shopify:block:select',
          this.handleBlockSelect
        );

        this.syncSelection(
          this.activeId
        );
      }

      isMobile() {
        return this.mobileQuery.matches;
      }

      getProduct(id) {
        return this.products.find(
          product =>
            product.dataset
              .rqsLuxlookProduct === id
        );
      }

      getHotspot(id) {
        return this.hotspots.find(
          hotspot =>
            hotspot.dataset
              .rqsLuxlookHotspot === id
        );
      }

      getHome(id) {
        return this.root.querySelector(
          `[data-rqs-luxlook-home="${id}"]`
        );
      }

      syncSelection(id) {
        if (!id) {
          return;
        }

        this.activeId = id;

        this.hotspots.forEach(hotspot => {
          const selected =
            hotspot.dataset
              .rqsLuxlookHotspot === id;

          hotspot.classList.toggle(
            'is-rqs-luxlook-active',
            selected
          );

          hotspot.setAttribute(
            'aria-pressed',
            selected ? 'true' : 'false'
          );
        });

        this.products.forEach(product => {
          product.classList.toggle(
            'is-rqs-luxlook-active',
            product.dataset
              .rqsLuxlookProduct === id
          );
        });
      }

      selectProduct(id, userTriggered) {
        const product =
          this.getProduct(id);

        if (!product) {
          return;
        }

        this.syncSelection(id);

        if (this.isMobile()) {
          this.openSheet(id);
          return;
        }

        this.returnSheetProduct();

        if (userTriggered) {
          product.focus({
            preventScroll: true
          });
        }
      }

      openSheet(id) {
        if (
          !this.sheet ||
          !this.sheetBody
        ) {
          return;
        }

        const product =
          this.getProduct(id);

        if (!product) {
          return;
        }

        if (
          this.sheetProduct &&
          this.sheetProduct !== product
        ) {
          this.returnSheetProduct();
        }

        this.sheetProduct = product;

        this.sheetBody.appendChild(
          product
        );

        product.classList.add(
          'is-rqs-luxlook-active'
        );

        if (this.sheetTitle) {
          this.sheetTitle.textContent =
            product.dataset
              .rqsProductTitle || '';
        }

        if (!this.sheet.open) {
          this.sheet.showModal();
        }

        document.documentElement
          .classList.add(
            'rqs-luxlook-document-locked'
          );

        window.requestAnimationFrame(
          () => {
            this.closeButton?.focus({
              preventScroll: true
            });
          }
        );
      }

      returnSheetProduct() {
        if (!this.sheetProduct) {
          return;
        }

        const id =
          this.sheetProduct.dataset
            .rqsLuxlookProduct;

        const home =
          this.getHome(id);

        if (home) {
          home.insertAdjacentElement(
            'afterend',
            this.sheetProduct
          );
        } else if (this.productStage) {
          this.productStage.appendChild(
            this.sheetProduct
          );
        }

        this.sheetProduct = null;
      }

      closeSheet() {
        if (
          this.sheet &&
          this.sheet.open
        ) {
          this.sheet.close();
        } else {
          this.handleSheetClose();
        }
      }

      handleSheetClick(event) {
        if (
          !this.sheet ||
          !this.sheetPanel
        ) {
          return;
        }

        if (
          event.target !== this.sheet
        ) {
          return;
        }

        const rect =
          this.sheetPanel
            .getBoundingClientRect();

        const outside =
          event.clientY < rect.top ||
          event.clientY > rect.bottom ||
          event.clientX < rect.left ||
          event.clientX > rect.right;

        if (outside) {
          this.closeSheet();
        }
      }

      handleSheetClose() {
        this.returnSheetProduct();

        const anotherOpenSheet =
          document.querySelector(
            '[data-rqs-luxlook-sheet][open]'
          );

        if (!anotherOpenSheet) {
          document.documentElement
            .classList.remove(
              'rqs-luxlook-document-locked'
            );
        }

        const hotspot =
          this.getHotspot(
            this.activeId
          );

        hotspot?.focus({
          preventScroll: true
        });
      }

      handleBreakpoint() {
        if (!this.isMobile()) {
          this.closeSheet();
          this.returnSheetProduct();
        } else if (
          this.sheet &&
          this.sheet.open
        ) {
          this.closeSheet();
        }

        this.syncSelection(
          this.activeId
        );
      }

      handleBlockSelect(event) {
        if (
          !this.root.contains(
            event.target
          )
        ) {
          return;
        }

        const product =
          event.target.closest?.(
            '[data-rqs-luxlook-product]'
          );

        if (!product) {
          return;
        }

        const id =
          product.dataset
            .rqsLuxlookProduct;

        this.syncSelection(id);
      }

      destroy() {
        this.closeSheet();
        this.returnSheetProduct();

        this.sheet?.removeEventListener(
          'click',
          this.handleSheetClick
        );

        this.sheet?.removeEventListener(
          'close',
          this.handleSheetClose
        );

        this.mobileQuery.removeEventListener(
          'change',
          this.handleBreakpoint
        );

        document.removeEventListener(
          'shopify:block:select',
          this.handleBlockSelect
        );
      }
    }

    const initialize = scope => {
      const roots =
        scope.matches?.(
          '[data-rqs-luxlook-root]'
        )
          ? [scope]
          : Array.from(
              scope.querySelectorAll?.(
                '[data-rqs-luxlook-root]'
              ) || []
            );

      roots.forEach(root => {
        if (
          registry.has(root.id)
        ) {
          return;
        }

        registry.set(
          root.id,
          new RqsLuxLookSheet(root)
        );
      });
    };

    initialize(document);

    document.addEventListener(
      'shopify:section:load',
      event => {
        initialize(
          event.target
        );
      }
    );

    document.addEventListener(
      'shopify:section:unload',
      event => {
        const root =
          event.target.matches?.(
            '[data-rqs-luxlook-root]'
          )
            ? event.target
            : event.target.querySelector?.(
                '[data-rqs-luxlook-root]'
              );

        if (!root) {
          return;
        }

        const instance =
          registry.get(root.id);

        instance?.destroy();
        registry.delete(root.id);
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
